import React, { useEffect, useState } from 'react'
import './sidebar.css'
import { Link, useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { toggleSideBar } from '../../state/settingsSlice'
import logo from "../../assets/Aspom-Logo.png"

import { SiGooglemeet } from "react-icons/si";
import { GiTeacher } from "react-icons/gi";
import { MdTranscribe } from "react-icons/md";

const Sidebar = () => {
    const location = useLocation()
    const dispatch = useDispatch()
    const {sidebar} = useSelector((state)=>state.settings)
    const {user} = useSelector((state)=>state.user)
    const [resize, setResize] = useState(false)
    const [subSidebar, setSubSidebar] = useState('')


    const handleSubSidebar = (val) => {
        if(subSidebar === val){
            setSubSidebar('')
        }else{
            setSubSidebar(val)
        }
    }

    const handleSidebar = () =>{
        dispatch(toggleSideBar(!sidebar))
    }

    const isMobile = window.innerWidth < 992;
    useEffect(() => {
        const handleResize = () => {
            if(isMobile){
                setResize(true)
                dispatch(toggleSideBar(false))
            }else{
                setResize(false)
            }
        };

        handleResize();

    }, [isMobile]);


  return (
    <aside className={`sidebar ${sidebar ? 'active' : ''}`}>
        <div className="sidebar__overlay" onClick={handleSidebar}></div>
        <div className="sidebar__inner">
            {/* SIDEBAR CONTAINER */}
            <div className="sidebar__container">
                {/* LOGO */}
                <img src={logo} className="sidebar__logo"/>

                {/* SIDEBAR MENU */}
                <div className="sidebar__menu">

                    {/* SIDEBAR LISTS */}
                    <ul className="sidebar__list">

                        {/* DASHBOARD */}
                        <li onClick={()=>resize ? dispatch(toggleSideBar(false)) : null}
                        className={`sidebar__item ${location.pathname === '/' && 'active'}`}>
                            <Link to='/' 
                            className='sidebar__link'>
                                <i class='bx bx-layout sidebar__link-icon'></i>
                                Dashboard
                            </Link>
                        </li>

                        {/* STAFF HANDBOOK */}
                        <li onClick={()=>resize ? dispatch(toggleSideBar(false)) : null}
                        className={`sidebar__item ${location.pathname === '/staff_hand_book' && 'active'}`}>
                            <Link to='/staff_hand_book' 
                            className='sidebar__link'>
                                <i class='bx bx-book-reader sidebar__link-icon'></i>
                                Staff hand book
                            </Link>
                        </li>

                        {/* NEWS STAND */}
                        <li onClick={()=>resize ? dispatch(toggleSideBar(false)) : null}
                        className={`sidebar__item ${location.pathname === '/news_stand' && 'active'}`}>
                            <Link to='/news_stand' 
                            className='sidebar__link'>
                                <i class='bx bx-news sidebar__link-icon'></i>
                                News stand
                            </Link>
                        </li>

                        {/* DEPARTMENTAL PORTAL */}
                        {
                            user?.department !== 'HR' && user?.role !== 'Administrator' &&
                            <div className="sidebar__has_sub-sidebar">
                                <li className={`sidebar__item`}>
                                        <button onClick={()=>handleSubSidebar('portal')}
                                        className='sidebar__link'>                                
                                            <i class='bx bx-compass sidebar__link-icon'></i>
                                            {user?.department} portal
                                        </button>
                                        {subSidebar === 'portal' ? <i class='bx bx-chevron-down sidebar__link-icon' ></i> 
                                        : <i class='bx bx-chevron-right sidebar__link-icon'></i>}
                                </li>
                                {/* SUB SIDEBARS */}

                                <ul className={`sub_sidebar__list ${subSidebar === 'portal' && 'active'}`}>

                                    {/* IT PORTAL */}
                                    {
                                        user?.department === 'IT' && (
                                            <>
                                                <li onClick={()=>resize ? dispatch(toggleSideBar(false)) : null}
                                                className={`sidebar__item ${location.pathname === '/assign-gadget' && 'active'}`}>
                                                    <Link to='/assign-gadget' 
                                                    className={`sidebar__link 
                                                    ${location.pathname === '/assign-gadget' ? 'active' : ''}`}>
                                                        All Gadgets
                                                    </Link>
                                                </li>
                                                <li onClick={()=>resize ? dispatch(toggleSideBar(false)) : null}
                                                className={`sidebar__item ${location.pathname === '/assign-gadget' && 'active'}`}>
                                                    <Link to='/assign-gadget' 
                                                    className={`sidebar__link 
                                                    ${location.pathname === '/assign-gadget' ? 'active' : ''}`}>
                                                        Assign Gadget
                                                    </Link>
                                                </li>
                                                <li onClick={()=>resize ? dispatch(toggleSideBar(false)) : null}
                                                className={`sidebar__item ${location.pathname === '/complaints' && 'active'}`}>
                                                    <Link to='/complaints' 
                                                    className={`sidebar__link 
                                                    ${location.pathname === '/complaints' ? 'active' : ''}`}>
                                                        Complaints
                                                    </Link>
                                                </li>
                                                <li onClick={()=>resize ? dispatch(toggleSideBar(false)) : null}
                                                className={`sidebar__item ${location.pathname === '/exist-form' && 'active'}`}>
                                                    <Link to='/exist-form' 
                                                    className={`sidebar__link 
                                                    ${location.pathname === '/exist-form' ? 'active' : ''}`}>
                                                        Exist form
                                                    </Link>
                                                </li>
                                            </>
                                        )
                                    }

                                    {/* GENERAL DEPARTMENTAL PORTAL */}
                                    <li onClick={()=>resize ? dispatch(toggleSideBar(false)) : null}
                                    className={`sidebar__item ${location.pathname === '/expense' && 'active'}`}>
                                        <Link to='/expense' 
                                        className={`sidebar__link 
                                        ${location.pathname === '/expense' ? 'active' : ''}`}>
                                            Expense
                                        </Link>
                                    </li>
                                    {
                                        user?.role === 'Supervisor' &&
                                        <li onClick={()=>resize ? dispatch(toggleSideBar(false)) : null}
                                        className={`sidebar__item ${location.pathname === '/employees_leave_request' && 'active'}`}>
                                            <Link to='/employees_leave_request' 
                                            className={`sidebar__link 
                                            ${location.pathname === '/employees_leave_request' ? 'active' : ''}`}>
                                                Team Leave Requests
                                            </Link>
                                        </li>
                                    }
                                </ul>
                            </div>
                        }

                        {/* HR/ADMINISTRATOR PORTAL */}
                        {
                            user?.department === 'HR' || user?.role === 'Administrator' ? ( 
                                <div className="sidebar__has_sub-sidebar">
                                    {/* SUBSIDEBAR BUTTON */}
                                    <li className={`sidebar__item`}>
                                        <button onClick={()=>handleSubSidebar('portal')}
                                        className='sidebar__link'>                                
                                            <i class='bx bx-compass sidebar__link-icon'></i>
                                            Department portal
                                        </button>
                                        {subSidebar === 'portal' ? <i class='bx bx-chevron-down sidebar__link-icon' ></i> 
                                            : <i class='bx bx-chevron-right sidebar__link-icon'></i>}
                                    </li>
                                    {/* SUB SIDEBAR */}
                                    <ul className={`sub_sidebar__list ${subSidebar === 'portal' && 'active'}`}>

                                        {/* ALL EMPLOYEES */}
                                        <li onClick={()=>resize ? dispatch(toggleSideBar(false)) : null}
                                        className={`sidebar__item ${location.pathname === '/employees' && 'active'}`}>
                                            <Link to='/employees' 
                                            className={`sidebar__link 
                                            ${location.pathname === '/employees' ? 'active' : ''}`}>
                                                All Employees
                                            </Link>
                                        </li>

                                        {/* DEPARTMENTS */}
                                        <li onClick={()=>resize ? dispatch(toggleSideBar(false)) : null}
                                        className={`sidebar__item ${location.pathname === '/department' && 'active'}`}>
                                            <Link to='/department' 
                                            className={`sidebar__link 
                                            ${location.pathname === '/department' ? 'active' : ''}`}>
                                                Departments
                                            </Link>
                                        </li>

                                        {/* HOLIDAYS */}
                                        <li onClick={()=>resize ? dispatch(toggleSideBar(false)) : null}
                                        className={`sidebar__item ${location.pathname === '/holiday' && 'active'}`}>
                                            <Link to='/holiday' 
                                            className={`sidebar__link 
                                            ${location.pathname === '/holiday' ? 'active' : ''}`}>
                                                Holidays
                                            </Link>
                                        </li>

                                        {/* STAFF ATTENDANCE */}
                                        <li onClick={()=>resize ? dispatch(toggleSideBar(false)) : null}
                                        className={`sidebar__item ${location.pathname === '/staff__attendance' && 'active'}`}>
                                            <Link to='/staff__attendance' 
                                            className={`sidebar__link 
                                            ${location.pathname === '/staff__attendance' ? 'active' : ''}`}>
                                                Staff Attendance
                                            </Link>
                                        </li>

                                        {/* STAFF APPRAISAL */}
                                        <li onClick={()=>resize ? dispatch(toggleSideBar(false)) : null}
                                        className={`sidebar__item ${location.pathname === '/appraisal' && 'active'}`}>
                                            <Link to='/appraisal' 
                                            className={`sidebar__link 
                                            ${location.pathname === '/appraisal' ? 'active' : ''}`}>
                                                Staff Appraisal
                                            </Link>
                                        </li>

                                        {/* STAFF TODO LIST */}
                                        <li onClick={()=>resize ? dispatch(toggleSideBar(false)) : null}
                                        className={`sidebar__item ${location.pathname === '/staff__todolist' && 'active'}`}>
                                            <Link to='/staff__todolist' 
                                            className={`sidebar__link 
                                            ${location.pathname === '/staff__todolist' ? 'active' : ''}`}>
                                                Staff Todo List
                                            </Link>
                                        </li>

                                        {/* STAFF REPORTS */}
                                        <li onClick={()=>resize ? dispatch(toggleSideBar(false)) : null}
                                        className={`sidebar__item ${location.pathname === '/staff__reports' && 'active'}`}>
                                            <Link to='/staff__reports' 
                                            className={`sidebar__link 
                                            ${location.pathname === '/staff__reports' ? 'active' : ''}`}>
                                                Staff Reports
                                            </Link>
                                        </li>

                                        {/* STAFF LEAVE REQUESTS */}
                                        <li onClick={()=>resize ? dispatch(toggleSideBar(false)) : null}
                                        className={`sidebar__item ${location.pathname === '/employees_leave_request' && 'active'}`}>
                                            <Link to='/employees_leave_request' 
                                            className={`sidebar__link 
                                            ${location.pathname === '/employees_leave_request' ? 'active' : ''}`}>
                                                Staff Leave Requests
                                            </Link>
                                        </li>

                                        {/* PAYROLL */}
                                        <li onClick={()=>resize ? dispatch(toggleSideBar(false)) : null}
                                        className={`sidebar__item ${location.pathname.includes('/payroll') && 'active'}`}>
                                            <Link to='/payroll' 
                                            className={`sidebar__link 
                                            ${location.pathname === '/payroll' ? 'active' : ''}`}>
                                                Payroll
                                            </Link>
                                        </li>

                                        {/* RESIGNATION */}
                                        <li onClick={()=>resize ? dispatch(toggleSideBar(false)) : null}
                                        className={`sidebar__item ${location.pathname === '/resignation' && 'active'}`}>
                                            <Link to='/resignation' 
                                            className={`sidebar__link 
                                            ${location.pathname === '/resignation' ? 'active' : ''}`}>
                                                Resignation
                                            </Link>
                                        </li>

                                        {/* TERMINATION */}
                                        <li onClick={()=>resize ? dispatch(toggleSideBar(false)) : null}
                                        className={`sidebar__item ${location.pathname === '/termination' && 'active'}`}>
                                            <Link to='/termination' 
                                            className={`sidebar__link 
                                            ${location.pathname === '/termination' ? 'active' : ''}`}>
                                                Termination
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            ) : ''
                        } 

                        {/* ATTENDANCE */}
                        <li onClick={()=>resize ? dispatch(toggleSideBar(false)) : null}
                        className={`sidebar__item ${location.pathname === '/attendance' && 'active'}`}>
                            <Link to={`/attendance`} 
                            className='sidebar__link'>
                                <i class='bx bx-user-check sidebar__link-icon'></i>
                                Attendance
                            </Link>
                        </li>

                        {/* TODO LIST */}
                        <li onClick={()=>resize ? dispatch(toggleSideBar(false)) : null}
                        className={`sidebar__item ${location.pathname === '/todo_list' && 'active'}`}>
                            <Link to={`/todo_list`} 
                            className='sidebar__link'>
                                <i class='bx bx-list-ol sidebar__link-icon'></i>
                                Todo list
                            </Link>
                        </li>

                        {/* END OF THE DAY REPORT */}
                        <li onClick={()=>resize ? dispatch(toggleSideBar(false)) : null}
                        className={`sidebar__item ${location.pathname === '/end_of_day_report' && 'active'}`}>
                            <Link to={`/end_of_day_report`} 
                            className='sidebar__link'>
                                <i class='bx bx-notepad sidebar__link-icon'></i>
                                End of day report
                            </Link>
                        </li>

                        {/* LEAVE REQUESTS */}
                        <li onClick={()=>resize ? dispatch(toggleSideBar(false)) : null}
                        className={`sidebar__item ${location.pathname === '/leave_request' && 'active'}`}>
                            <Link to={`/leave_request`} 
                            className='sidebar__link'>
                                <i class='bx bx-registered sidebar__link-icon'></i>
                                Leave Request
                            </Link>
                        </li>

                        {/* LEAVE REQUEST STATUS */}
                        <li onClick={()=>resize ? dispatch(toggleSideBar(false)) : null}
                        className={`sidebar__item ${location.pathname === '/leave_request_status' && 'active'}`}>
                            <Link to={`/leave_request_status`} 
                            className='sidebar__link'>
                                <i class='bx bx-loader-circle sidebar__link-icon'></i>
                                Leave Request Status
                            </Link>
                        </li>

                        {/* SUBMIT APPRAISAL */}
                        <li onClick={()=>resize ? dispatch(toggleSideBar(false)) : null}
                        className={`sidebar__item ${location.pathname === '/submit_appraisal' && 'active'}`}>
                            <Link to={`/submit_appraisal`} 
                            className='sidebar__link'>
                                <i class='bx bx-user-pin sidebar__link-icon'></i>
                                Submit appraisal
                            </Link>
                        </li>

                        {/* APPRAISAL TRACKER */}
                        <li onClick={()=>resize ? dispatch(toggleSideBar(false)) : null}
                        className={`sidebar__item ${location.pathname === '/appraisal_tracker' && 'active'}`}>
                            <Link to='/appraisal_tracker' 
                            className='sidebar__link'>
                                <i class='bx bx-current-location sidebar__link-icon'></i>
                                Appraisal tracker
                            </Link>
                        </li>

                        {/* CHAT ROOM */}
                        <li onClick={()=>resize ? dispatch(toggleSideBar(false)) : null}
                        className={`sidebar__item ${location.pathname === '/chat_room' && 'active'}`}>
                            <Link to='/chat_room' 
                            className='sidebar__link'>
                                <i class='bx bx-chat sidebar__link-icon'></i>
                                Chat room
                            </Link>
                        </li>

                        {/* EMAIL */}
                        {/* <li onClick={()=>resize ? dispatch(toggleSideBar(false)) : null}
                        className={`sidebar__item ${location.pathname === '/email' && 'active'}`}>
                            <Link to='/email' 
                            className='sidebar__link'>
                                <i class='bx bx-envelope sidebar__link-icon'></i>
                                Email
                            </Link>
                        </li> */}

                        {/* VIRTUAL MEETING */}
                        <li onClick={()=>resize ? dispatch(toggleSideBar(false)) : null}
                        className={`sidebar__item ${location.pathname === '/meeting' && 'active'}`}>
                            <Link to='/' 
                            className='sidebar__link'>
                                <SiGooglemeet className="sidebar__link-icon" size={18}/>
                                Meeting
                            </Link>
                        </li>
                        
                        {/* TRAINING */}
                        <li onClick={()=>resize ? dispatch(toggleSideBar(false)) : null}
                        className={`sidebar__item ${location.pathname === '/training' && 'active'}`}>
                            <Link to='/' 
                            className='sidebar__link'>
                                <GiTeacher className="sidebar__link-icon" size={18}/>
                                Training
                            </Link>
                        </li>
                        
                        {/* QUERY & RESPONSE */}
                        <li onClick={()=>resize ? dispatch(toggleSideBar(false)) : null}
                        className={`sidebar__item ${location.pathname === '/query-&-response' && 'active'}`}>
                            <Link to='/' 
                            className='sidebar__link'>
                                <MdTranscribe className="sidebar__link-icon" size={18}/>
                                Query & Response
                            </Link>
                        </li>
                        
                        {/* RESOLUTION CASE */}
                        <li onClick={()=>resize ? dispatch(toggleSideBar(false)) : null}
                        className={`sidebar__item ${location.pathname === '/ticket' && 'active'}`}>
                            <Link to='/ticket' 
                            className='sidebar__link'>
                                <i class='bx bx-error-alt sidebar__link-icon'></i>
                                Resolution case
                            </Link>
                        </li>

                        {/* SETTINGS */}
                        {
                            user?.role === 'Administrator' &&
                            <li onClick={()=>resize ? dispatch(toggleSideBar(false)) : null}
                            className={`sidebar__item ${location.pathname === '/settings' && 'active'}`}>
                                <Link to='/settings' 
                                className='sidebar__link'>
                                    <i class='bx bx-error-alt sidebar__link-icon'></i>
                                    Settings
                                </Link>
                            </li>
                        }

                    </ul>

                </div>
            </div>
        </div>
    </aside>
  )
}

export default Sidebar